import { createAuthClient } from 'better-auth/react'

// Extract the base API URL without any path suffixes
const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:4001'
// Remove any trailing paths like '/prepare' from the API URL
const baseApiUrl = apiUrl.replace(/\/prepare\/?$/, '')
const baseURL = baseApiUrl + '/auth'

export const authClient = createAuthClient({
  baseURL: baseURL,
  fetchOptions: {
    // Override any global fetch configurations
    credentials: 'include',
  },
  // Add additional configuration for better logout handling
  plugins: [],
})

export const { signIn, signUp, signOut, useSession, getSession, $Infer } =
  authClient
